import { type FilterMeta } from '@src/components/filter/components';
import { cloneDeep } from 'lodash';
import { ECO_RESERVED_DIMENSIONS } from '@src/components/app-viewer-sessions/utils';
import { isAppModule } from '../constants';
import { type Dimension } from './isValidSavedFilter';

export const getValidFilterDimensionMeta = (
  dimensionMeta: FilterMeta['dimensions'],
  allDimensions: Dimension[],
) => {
  let newDimensionMeta = cloneDeep(dimensionMeta);
  const validDimensionSet = new Set([
    ...allDimensions.map((it) => it.field),
    ...(isAppModule ? ECO_RESERVED_DIMENSIONS : []),
  ]);
  newDimensionMeta.forEach((d) => {
    d.fields = d.fields.filter((it) => validDimensionSet.has(it.value));
  });

  newDimensionMeta = newDimensionMeta.filter((it) => it.fields?.length > 0);
  return newDimensionMeta;
};
